import { isChainHeadSelector } from 'selectors/index';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { downloadBondRenewalReport, fetchBondRenewal } from 'dashboard/actions/bond-renewal/bond-renewal.actions';
import { isRetailerDashboardSelector } from 'selectors';
import tabs from 'contact/components/contact-us/tabs';
import template from './bond-renewal-widget.html';

const mapStateToThis = (state) => {
  const { session, config, bondRenewal } = state;
  const { retailer } = session;
  const isChainHead = isChainHeadSelector({ session });
  const { bondRenewalMaxDaysNo, bondRenewalLimitDays, bondRenewalInquiryReasonId } = config;
  const { isLoading, stores, storesCount } = bondRenewal;
  const isEmpty = storesCount === 0;
  const { CONTACT_THE_LOTTERY } = tabs;
  const isPreviewingRetailerDashboards = isRetailerDashboardSelector(state);

  return {
    retailer,
    isChainHead,
    bondRenewalMaxDaysNo,
    bondRenewalLimitDays,
    bondRenewalInquiryReasonId,
    isLoading,
    stores,
    storesCount,
    isEmpty,
    isPreviewingRetailerDashboards,
    CONTACT_THE_LOTTERY,
  };
};

const mapDispatchToThis = {
  downloadBondRenewalReport,
  fetchBondRenewal,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$state', '$ngRedux', 'widgetService')
class BondRenewalWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.widgetConfig = this.widgetService.initConfig({ configName: 'bondRenewal' });
    this.$scope.$applyAsync(this.fetchBondRenewal(this.retailerId));
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class BondRenewalWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
    this.template = template;
    this.controller = BondRenewalWidgetController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/bond-renewal/bond-renewal-widget-component.js